import styled from 'styled-components';
import { unthemed, zIndex } from 'tokens';

interface PrototypeContainerProps {
	backgroundColor: string;
}
export const PrototypeContainer = styled.div<PrototypeContainerProps>`
	flex: 1;
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	background-color: ${(props) => props.backgroundColor};
`;

interface FrameContainerProps {
	x: number;
	y: number;
	width: number;
	height: number;
	scale: number;
	backgroundColor?: string;
}

export const FrameContainer = styled.div<FrameContainerProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	transform: scale(${(props) => props.scale});
	transform-origin: top left;
	background: ${(p) => p.backgroundColor ?? p.theme.gray[900]};
`;

interface FrameStatusOverlayProps {
	x: number;
	y: number;
	width: number;
	height: number;
	scale: number;
}

export const FrameStatusOverlay = styled.div<FrameStatusOverlayProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	transform: scale(${(props) => props.scale});
	transform-origin: top left;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: ${unthemed.gray[900]}bb;
`;

export const FrameStatusContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const ScaledStatusIndicator = styled.div<{ scale: number }>`
	display: flex;
	justify-content: center;
	align-items: end;
	margin-bottom: ${(props) => 22 / props.scale}px;

	svg,
	img {
		width: ${(props) => 36 / props.scale}px !important;
		height: ${(props) => 36 / props.scale}px !important;
	}
`;

export const ScaledOverlayText = styled.div<{ scale: number }>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: calc(100% - ${(props) => 60 / props.scale}px);
	max-width: ${(props) => 600 / props.scale}px;
	padding-left: ${(props) => 30 / props.scale}px;
	padding-right: ${(props) => 30 / props.scale}px;
	margin-bottom: ${(props) => 20 / props.scale}px;
	font-family: 'JetBrains Mono', sans-serif;
	font-size: ${(props) => 15 / props.scale}px;
	font-weight: 600;
	color: ${unthemed.gray[100]};
	text-align: center;
	line-height: 1.7;
	word-break: break-word;
	overflow-wrap: break-word;
`;

export const ScaledButton = styled.div<{ scale: number }>`
	transform: scale(${(props) => 1 / props.scale});
	transform-origin: center;
`;

interface ResizeHandleProps {
	side: 'left' | 'right';
	x: number;
	y: number;
	height: number;
}

export const ResizeHandle = styled.div<ResizeHandleProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: 4px;
	height: ${(props) => props.height}px;
	background: transparent;
	border-${(props) => props.side}: 1px solid ${({ theme }) => theme.gray[200]};
	cursor: col-resize;
	z-index: ${zIndex.panel};

	&:hover {
		border-${(props) => props.side}: 1px solid ${({ theme }) => theme.gray[400]};
	}
`;

export const DevicePresetToolbar = styled.div`
	position: absolute;
	top: 16px;
	right: 16px;
	display: flex;
	align-items: center;
	gap: 4px;
	background: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	padding: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	z-index: 1000;
`;

interface DevicePresetButtonProps {
	active?: boolean;
}

export const DevicePresetButton = styled.button<DevicePresetButtonProps>`
	background: ${({ theme, active }) => (active ? theme.gray[200] : 'transparent')};
	border: none;
	padding: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: ${({ theme, active }) => (active ? theme.gray[200] : theme.gray[100])};
	}
`;
